import { IdType } from './common';

export enum Roles {
  ROOT_ADMIN = 'root',
  ADMIN = 'l1admin',
}
export interface User {
  id: IdType;
  username: string;
  email: string;
  roles: string;
  roles_array: Roles[];
  is_active: boolean;
  is_2fa: boolean;
}
